import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import type { RootState } from '../../store/store';
import { resolveBoitageRowVisibility } from '../../utils/boitageTimeline';
import { ROUTES } from '../../utils/routes';
import ModulesOverview from '../NewDashboard/components/ModulesOverview';
import PlanningModule from '../NewDashboard/components/PlanningModule';
import PrealableSection from '../NewDashboard/components/PrealableSection';
import SubscriptionBanner from '../NewDashboard/components/SubscriptionBanner';
import PenalModal from './components/PenalModal';
import StrategySection from './components/StrategySection';
import WelcomeCard from './components/WelcomeCard';

function CroissanceLanding() {
  const [isPenalModalOpen, setIsPenalModalOpen] = useState(false);
  const navigate = useNavigate();

  const { company, jwt } = useSelector((state: RootState) => ({
    company: state.auth.company,
    jwt: state.auth.token,
  }));

  const isLoggedIn = Boolean(company && jwt);

  const boitageEnabled = useMemo(() => {
    const currentYear = new Date().getFullYear();
    return resolveBoitageRowVisibility(company, currentYear);
  }, [company]);

  return (
    <div className="relative min-h-screen leading-relaxed text-gray-800">
      <div className="">
        <div className="flex flex-col gap-6">
          <WelcomeCard
            onOpenPenalModal={() => setIsPenalModalOpen(true)}
            onGoToMarketVision={isLoggedIn ? () => navigate(ROUTES.ANALYZING_MARKET_VISION) : undefined}
          />

          <PrealableSection />

          <StrategySection />

          <PlanningModule />

          <ModulesOverview boitageEnabled={boitageEnabled} />

          <SubscriptionBanner company={company} jwt={jwt} />
        </div>
      </div>

      <PenalModal isOpen={isPenalModalOpen} onClose={() => setIsPenalModalOpen(false)} />
    </div>
  );
}

export default CroissanceLanding;
